/* @refresh reload */
import { render } from 'solid-js/web';
import './index.css';
import App from './App';
import { StatsPage } from './components/StatsPage';
import { JoinPage } from './components/JoinPage';
import { ProfilePage } from './components/ProfilePage';
import { HomePage } from './components/HomePage';
import { MakerPage } from './components/MakerPage';
import { accountRedirect } from './lib/join';

const root = document.getElementById('root');
if (!root) throw new Error('#root missing');
// /stats, /join, /signin, /reset, /you, /home and /@<handle> are the pages that are not the feed: they mount no Carousel and no
// transport, so opening one never starts a card session on card 0 — reading the numbers, or
// creating an account or signing in without being dropped into the feed first. Decided here,
// before anything renders; so is sending the old account doors (/feed?signup=1, ?signin=1) to
// their pages, which must happen before the feed mounts for the same reason. App stays a static
// import because it captures the email-confirmation fragment at module load (INITIAL_HASH,
// App.tsx); a lazy import would evaluate after supabase-js had stripped it.
const path = location.pathname.replace(/\/+$/, '');
const moved = accountRedirect(location);
if (moved) location.replace(moved);
else
  render(
    () =>
      path === '/stats' ? <StatsPage /> : path === '/you' ? <ProfilePage /> : path === '/home' ? <HomePage /> : path.startsWith('/@') ? <MakerPage /> : path === '/join' || path === '/signin' || path === '/reset' ? <JoinPage /> : <App />,
    root,
  );
